<template>
  <div
    class="col-6 col-md filter-container"
    v-if="activeTab === artworksScope"
  >
    <h4>{{ I18n.t('search_page.artworks_tab.filters.state.title') }}</h4>
    <ul data-filter-group>
      <li>
        <button @click="changeFilters(soldValue)"
                :class="{ 'filter--selected': isActive(soldValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.state.values.sold') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
      <li>
        <button @click="changeFilters(soldConditionallyValue)"
                :class="{ 'filter--selected': isActive(soldConditionallyValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.state.values.sold_conditionally') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
      <li>
        <button @click="changeFilters(unsoldValue)"
                :class="{ 'filter--selected': isActive(unsoldValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.state.values.unsold') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
      <li>
        <button @click="selectOnlyAllFilter()"
                :class="{ 'filter--selected': isActive(allValue) }"
                class="filter text-left" type="button">
          {{ I18n.t('search_page.artworks_tab.filters.state.values.all') }}
          <span class="icon icon-close-big"></span>
        </button>
      </li>
    </ul>
  </div>
</template>

<script>
  import Helpers from '@/shared/mixins/artworks_filters_helpers';
  import { mapGetters, mapState, mapActions } from 'vuex';
  import { ARTWORKS_FILTERS, SCOPES } from '../../../consts';

  export default {
    name: 'StateFilterColumn',
    data() {
      return {
        soldValue: ARTWORKS_FILTERS.STATES.VALUES.SOLD,
        soldConditionallyValue: ARTWORKS_FILTERS.STATES.VALUES.SOLD_CONDITIONALLY,
        unsoldValue: ARTWORKS_FILTERS.STATES.VALUES.UNSOLD,
        allValue: ARTWORKS_FILTERS.STATES.VALUES.ALL,
        path: ARTWORKS_FILTERS.STATES.PATH,
        artworksScope: SCOPES.ARTWORKS,
      };
    },
    computed: {
      ...mapGetters(['filterValue']),
      ...mapState(['activeTab']),
      activeValues() {
        return this.filterValue(this.path);
      },
    },
    mixins: [Helpers],
    methods: {
      ...mapActions(['getArtworksWhenFilterIsChanging']),
      changeFilters(value) {
        const updatedValues = this.removeTheAllFilterIfActive(
          this.updatedActiveValues(value),
        );
        this.getArtworksWhenFilterIsChanging({ path: this.path, value: updatedValues });
      },
      removeTheAllFilterIfActive(values) {
        if (values.includes(this.allValue)) {
          return values.filter(e => e !== this.allValue);
        }
        return values;
      },
      selectOnlyAllFilter() {
        const value = (this.activeValues.includes(this.allValue)) ? [] : [this.allValue];
        this.getArtworksWhenFilterIsChanging({ path: this.path, value });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// app/javascript/packs/search_page/index/components/artworks_tab/filters/state_filter_column.vue?54dc92e2